<div class="sale-item-bulk-update-container page-root-container">

    <!-- Header Area -->
    <div class="page-header" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="page-title"
            style="display: flex; align-items: center; gap: 8px; font-size: 20px; font-weight: 500;">
            <img class="icon" src="assets/images/menu/svg/sale-item-bulk-update.svg">
            <span class="title" style="text-transform: uppercase;">
                BULK UPDATE<span *ngIf="update_schedule_at"> - {{ scheduledDateVal?.format('DD/MM/YYYY') }}</span>
            </span>

            <!-- Calendar Picker trigger -->
            @if (update_schedule_at && permission?.can_publish) {
            <button mat-icon-button (click)="openScheduleDialog()" title="Edit Schedule Date"
                style="width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; background-color: #e0e0e0; border-radius: 50%; padding: 0; min-width: unset; line-height: normal; flex-shrink: 0;">
                <mat-icon
                    style="font-size: 16px; width: 16px; height: 16px; line-height: 16px; color: #666; display: flex; align-items: center; justify-content: center;">edit</mat-icon>
            </button>
            }
        </div>

        <div class="page-actions" style="display: flex; gap: 8px;">
            @if (update_schedule_at && permission?.can_delete) {
            <button mat-button class="btn-discard" (click)="discardStagingData()"
                style="border-radius: 4px;">
                <mat-icon
                    style="font-size: 18px; width: 18px; height: 18px; line-height: 18px; margin-right: 4px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;">delete</mat-icon>
                Discard
            </button>
            }
            @if (update_schedule_at && permission?.can_publish) {
            <button mat-button class="btn-publish" (click)="publishStagingData()"
                style="border-radius: 4px;">
                <mat-icon
                    style="font-size: 18px; width: 18px; height: 18px; line-height: 18px; margin-right: 4px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;">publish</mat-icon>
                Publish
            </button>
            }
            @if (permission?.can_import) {
            <button mat-button color="primary" class="btn-add" (click)="openImportDialog()" style="border-radius: 4px;">
                <mat-icon
                    style="font-size: 18px; width: 18px; height: 18px; line-height: 18px; margin-right: 4px; display: inline-flex; align-items: center; justify-content: center; vertical-align: middle;">cloud_upload</mat-icon>
                Import
            </button>
            }
            @if (permission?.can_export) {
            <button mat-button color="accent" class="btn-export" (click)="openExportDialog()"
                style="border-radius: 4px;">
                <img class="download-icon" src="assets/images/animated/download/download-no-anim.svg">
                Export
            </button>
            }
        </div>
    </div>

    <!-- Active Schedule Warning -->
    <div class="active-alert-bar" *ngIf="update_schedule_at"
        style="padding: 8px 12px; background-color: #e8f5e9; color: #2e7d32; border-radius: 4px; margin-bottom: 8px; font-size: 13.5px; display: flex; align-items: center; gap: 8px; border: 1px solid #c8e6c9;">
        <mat-icon
            style="font-size: 18px; width: 18px; height: 18px; color: #2e7d32; line-height: 18px;">check_circle</mat-icon>
        <span style="font-weight: 500; letter-spacing: 0.2px;">
            Sale item bulk update list has been imported successfully. All new updates will be published on {{
            originalScheduleDate | date:'dd-MM-yyyy' }} 00:00
        </span>
    </div>

    <!-- Main Table View & Search Filter -->
    <div class="data-container"
        style="display: flex; flex-direction: column; flex: 1; overflow: hidden; background: white;">
        <app-loader [show]="isLoading"></app-loader>

        <app-search-filter #searchFilter *ngIf="update_schedule_at" [pagingData]="pagingData"
            [pageSizeOptions]="[5,10,20,50,100]" [filter]="filter" (page)="onePageEvent($event)"
            (onApply)="onFilterApplied($event)" [hidePageSize]="true">
        </app-search-filter>

        <section tabindex="0" class="table-container" *ngIf="update_schedule_at" style="flex: 1; overflow: auto;">
            <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)" style="width: 100%;">

                <!-- Sl Column -->
                <ng-container matColumnDef="sl">
                    <th mat-header-cell *matHeaderCellDef style="width: 5%;">Sl</th>
                    <td mat-cell *matCellDef="let item; let i = index" style="width: 5%;">
                        {{ i + 1 + (pagingData.pageIndex * pagingData.pageSize) }}
                    </td>
                </ng-container>

                <!-- Code Column -->
                <ng-container matColumnDef="code">
                    <th mat-sort-header="sale_item.code" mat-header-cell *matHeaderCellDef style="width: 10%;">Item Code
                    </th>
                    <td mat-cell *matCellDef="let item" style="width: 10%;">{{ item.item_code }}</td>
                </ng-container>

                <!-- Class Column -->
                <ng-container matColumnDef="class">
                    <th mat-header-cell *matHeaderCellDef style="width: 12%;">Sub Class</th>
                    <td mat-cell *matCellDef="let item" style="width: 12%;">{{ item.item_class_name || '-' }}</td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <th mat-sort-header="sale_item.name" mat-header-cell *matHeaderCellDef style="width: 20%;">Name</th>
                    <td mat-cell *matCellDef="let item" style="width: 20%;">{{ item.item_name }}</td>
                </ng-container>

                <!-- Name(New) Column -->
                <ng-container matColumnDef="new_name">
                    <th mat-header-cell *matHeaderCellDef style="width: 20%;">Name(New)</th>
                    <td mat-cell *matCellDef="let item" style="width: 20%;"
                        [ngClass]="{'modified-cell-text': item.new_item_name && item.new_item_name !== item.item_name}">
                        {{ item.new_item_name || '-' }}
                    </td>
                </ng-container>

                <!-- Name To Print(New) Column -->
                <ng-container matColumnDef="new_print_name">
                    <th mat-header-cell *matHeaderCellDef style="width: 20%;">Name To Print(New)</th>
                    <td mat-cell *matCellDef="let item" style="width: 20%;"
                        [ngClass]="{'modified-cell-text': item.new_item_name_to_print && item.new_item_name_to_print !== item.item_name_to_print}">
                        {{ item.new_item_name_to_print || '-' }}
                    </td>
                </ng-container>

                <!-- Short Name(New) Column -->
                <ng-container matColumnDef="new_short_name">
                    <th mat-header-cell *matHeaderCellDef style="width: 15%;">Short Name(New)</th>
                    <td mat-cell *matCellDef="let item" style="width: 15%;"
                        [ngClass]="{'modified-cell-text': item.new_item_short_name && item.new_item_short_name !== item.short_name}">
                        {{ item.new_item_short_name || '-' }}
                    </td>
                </ng-container>

                <!-- Price Column -->
                <ng-container matColumnDef="price">
                    <th mat-sort-header="sale_item.fixed_price" mat-header-cell *matHeaderCellDef
                        style="width: 12%; text-align: right; padding-right: 16px;">Price</th>
                    <td mat-cell *matCellDef="let item" style="width: 12%; text-align: right; padding-right: 16px;">
                        {{ item.fixed_price | currency:'USD':'symbol':'1.2-2' }}
                    </td>
                </ng-container>

                <!-- Price(New) Column -->
                <ng-container matColumnDef="new_price">
                    <th mat-sort-header="sale_item.fixed_price" mat-header-cell *matHeaderCellDef
                        style="width: 12%; text-align: right; padding-right: 16px;">Price(New)</th>
                    <td mat-cell *matCellDef="let item" style="width: 12%; text-align: right; padding-right: 16px;"
                        [ngClass]="{'modified-cell-text': item.new_fixed_price !== null && item.new_fixed_price !== undefined}">
                        <div style="display: flex; align-items: center; justify-content: flex-end; gap: 4px;">
                            <mat-icon *ngIf="item.has_shop_price > 0"
                                style="font-size: 16px; width: 16px; height: 16px; color: #f44336;"
                                title="Has Shop Price">
                                storefront
                            </mat-icon>
                            <span>
                                {{ (item.new_fixed_price !== null && item.new_fixed_price !== undefined ?
                                item.new_fixed_price : '-') | currency:'USD':'symbol':'1.2-2' }}
                            </span>
                        </div>
                    </td>
                </ng-container>

                <!-- To Be Deleted Column -->
                <ng-container matColumnDef="is_to_be_deleted">
                    <th mat-header-cell *matHeaderCellDef style="width: 15%; text-align: center;">To Be Deleted</th>
                    <td mat-cell *matCellDef="let item"
                        style="width: 15%; text-align: center; color: #e53935; font-weight: 500;">
                        {{ item.is_to_be_deleted === 1 ? 'Yes' : 'No' }}
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let item; columns: displayedColumns;"
                    [ngClass]="{'row-deleted': item.is_to_be_deleted === 1}"></tr>
            </table>
        </section>

        <!-- No Data View -->
        <div class="no-data-container" *ngIf="!update_schedule_at || pagingData.length <= 0"
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 48px; text-align: center; flex: 1;">
            <img src="assets/images/no-data.png" alt="No data found"
                style="width: 150px; margin-bottom: 16px; opacity: 0.7;">
            <span class="no-data-info" style="color: #666; font-size: 15px;">No staged bulk update edits found. Import a
                revision spreadsheet to populate this dashboard.</span>
        </div>
    </div>
</div>